import React, { useState } from "react";

function classNames(...inputs) {
  const out = [];
  const visit = (x) => {
    if (x == null || x === false) return;
    const t = typeof x;
    if (t === "string" || t === "number") {
      const s = String(x).trim();
      if (s) out.push(s);
      return;
    }
    if (Array.isArray(x)) { x.forEach(visit); return; }
    if (t === "object") {
      for (const k in x) {
        if (!Object.prototype.hasOwnProperty.call(x, k)) continue;
        if (x[k]) out.push(k);
      }
      return;
    }
  };
  inputs.forEach(visit);
  return out.join(" ");
}

const formatTooltipCurrency = (amount) => {
  return `₹${Math.round(amount).toLocaleString("en-IN")}`;
};

function DTICalculator({ prospectiveEMI = 0 }) {
  const [income, setIncome] = useState(100000);
  const [otherEmi, setOtherEmi] = useState(0);

  const totalEmi = (Number(otherEmi) || 0) + (Number(prospectiveEMI) || 0);
  const ratio = income ? (totalEmi / income) * 100 : 0;

  let verdict = "Healthy";
  let verdictColor = "bg-green-50 dark:bg-green-900";
  if (ratio >= 50) {
    verdict = "High risk";
    verdictColor = "bg-red-50 dark:bg-red-900";
  } else if (ratio >= 40) {
    verdict = "Elevated";
    verdictColor = "bg-amber-50 dark:bg-amber-900";
  }

  return (
    <div className="rounded-2xl p-6 ring-1 ring-neutral-200 dark:ring-neutral-700 bg-white dark:bg-neutral-800 shadow-lg">
      <h4 className="font-semibold mb-1 text-neutral-800 dark:text-neutral-100">Debt-to-Income (DTI) Ratio Calculator</h4>
      <p className="text-sm text-neutral-600 dark:text-neutral-200 mb-4">
        Banks prefer DTI ≤ 40%. Check your loan eligibility instantly.
      </p>
      <div className="grid sm:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm text-neutral-700 dark:text-neutral-200 mb-1">Monthly income (₹)</label>
          <input
            type="number"
            value={income}
            min={0}
            onChange={(e) => setIncome(Math.max(0, Number(e.target.value)))}
            className="w-full rounded-xl border border-neutral-300 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100 p-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
          />
        </div>
        <div>
          <label className="block text-sm text-neutral-700 dark:text-neutral-200 mb-1">Other EMIs (₹/mo)</label>
          <input
            type="number"
            value={otherEmi}
            min={0}
            onChange={(e) => setOtherEmi(Math.max(0, Number(e.target.value)))}
            className="w-full rounded-xl border border-neutral-300 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100 p-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
          />
        </div>
        <div>
          <label className="block text-sm text-neutral-700 dark:text-neutral-200 mb-1">This loan EMI (₹/mo)</label>
          <input
            type="number"
            value={Math.round(prospectiveEMI || 0)}
            readOnly
            className="w-full rounded-xl border border-neutral-300 dark:border-neutral-700 p-2.5 bg-neutral-50 dark:bg-neutral-700 dark:text-neutral-100 cursor-not-allowed"
          />
        </div>
      </div>
      <div className={classNames("mt-4 p-4 rounded-xl", verdictColor)}>
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm text-neutral-600 dark:text-neutral-200">DTI Ratio</div>
            <div className="text-lg font-semibold text-neutral-800 dark:text-neutral-100">{ratio.toFixed(1)}%</div>
          </div>
          <div className="text-right">
            <div className="text-sm text-neutral-600 dark:text-neutral-200">Status</div>
            <div className="font-semibold text-neutral-800 dark:text-neutral-100">{verdict}</div>
          </div>
        </div>
        <div className="mt-2 text-xs text-neutral-600 dark:text-neutral-200">
          Total monthly EMI: {formatTooltipCurrency(totalEmi)} of {formatTooltipCurrency(income)} income
        </div>
      </div>
    </div>
  );
}

export default DTICalculator;
